import httpClient from "@plugins/http";

const setSequentialSectionCompletionPrerequisite = (params) => {
  return httpClient.post(
    `/apis/rule-condition/previous-prerequisite/save/${params.lessonUuid}?isPreviousCompletionPrerequisite=${params.isSequentialSectionCompletionPre}`,
  );
};

const setSequentialActivityCompletionPrerequisite = (params) => {
  return httpClient.post(
    `/apis/rule-condition/previous-prerequisite/activity/save/${params.lessonUuid}?sectionId=${params.sectionId}&isPreviousCompletionPrerequisite=${params.isSequentialActivityCompletionPre}`,
  );
};

const setRuleConditionResourcePrerequisite = (uuid, requestData) => {
  return httpClient.post(`/apis/rule-condition/resource-prerequisite/save/${uuid}`, requestData);
};

const fetchAllRuleConditions = (lessonUuid, resourceStatus) => {
  return httpClient.get(`/apis/rule-condition/all/${lessonUuid}?resourceStatus=${resourceStatus}`);
};

const fetchActivityRuleCondition = (lessonUuid, resourceStatus, activityId, assignmentUuid) => {
  return httpClient.get(
    `/apis/rule-condition/activity/${lessonUuid}?resourceStatus=${resourceStatus}&activityId=${activityId}&assignmentUuid=${assignmentUuid}`,
  );
};

const getTeamResponse = (conditionTargetId) => {
  return httpClient.get(`/apis/rule-condition/team-response/${conditionTargetId}`);
};

export default {
  setSequentialSectionCompletionPrerequisite,
  setSequentialActivityCompletionPrerequisite,
  setRuleConditionResourcePrerequisite,
  fetchAllRuleConditions,
  getTeamResponse,
  fetchActivityRuleCondition,
};
